module.exports = __webpack_public_path__ + "img/Tarjetas_Cencosud.6ccc0bfa.png";